import { GrafanaFaroConfigModel } from '@libs/shared/common';

export const grafanaFaroConfig: GrafanaFaroConfigModel = {
  url: 'https://beacon.lekkerland.io/collect',
  secret: 'vqXLG7IdNUNLvYGdKdCcQwc5',
};
